import axios from 'axios';
// import { API_BASE_URI } from '../../environments';
import environments from '../../environments';

class ApiClient {
  constructor() {
    this.client = axios.create({
      baseURL: environments.API_BASE_URI,
      headers: { 'Content-Type': 'application/json' },
      // timeout: REQUEST_TIMEOUT,
    });
  }

  postEmail(email, sessionId) {
    return this.client.post(`/mail?s=${sessionId}`, { email });
  }

  getHolidays() {
    return this.client.get('/holiday');
  }

  getFlightList() {
    return this.client.get('/flightList');
  }
}

// Singleton
export const apiClient = new ApiClient();
